import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-unknown-component-editor',
  templateUrl: './unknown-component-editor.component.html',
  styleUrls: ['./unknown-component-editor.component.css'],
  standalone: false,
})
export class UnknownComponentEditorComponent {
  @Input() component: Component;
}
